import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

MonoMultiSubtitle.propTypes = {
    task: PropTypes.shape({
        monoOrMulti: PropTypes.shape({
            isMono: PropTypes.bool,
            isMulti: PropTypes.bool,
        })
    }).isRequired
};

function MonoMultiSubtitle({task}) {
    if (!task || !task.monoOrMulti) {
        return null;
    }

    const {isMono, isMulti} = task.monoOrMulti;

    if (isMono === false && isMulti === true) {
        return <FormattedMessage id='wms.myPickingMission.multi' />
    }

    if (isMono === true && isMulti === false) {
        return <FormattedMessage id='wms.myPickingMission.mono' />
    }

    if (isMono === true && isMulti === true) {
        return  <FormattedMessage id='wms.myPickingMission.monomulti' />
    }

    if (isMono === false && isMulti === false) {
        return null;
    }

    return null;
}

export default MonoMultiSubtitle;
